export default "__VITE_ASSET__C2GIYy9V__"